<template>
    <div class="dashboard bookings locations costSaleServices">
        <div class="head">
            <div class="title">
                <span> Service Types </span>
            </div>
        </div>
        
        <div class="search-booking">
            <div class="item">
                <branch-select @onBranch="onHandleBranch"></branch-select>
            </div>
            <div class="item">
                <label for="">Fechas</label>
                <input-date-picker v-model="date" :currentDate="date"></input-date-picker>    
            </div>
            <div class="item">
                <vs-button color="primary"  @click="search()" type="filled" icon="search" :disabled="!this.date != ''"></vs-button>
                <vs-button color="warning"  @click="reset()" type="filled" icon="backspace" v-if="date != ''"></vs-button>
            </div>
        </div>

        <div class="title book-title">Line Graph</div>

        <div class="box-white">
            <line-chart :key="key" :labels="stats.labels" :options="stats.value" title="Service Types" v-if="loaded"></line-chart>
        </div>
        
        <div class="title book-title">Summary</div>

        <table-service-types Types :items="stats.items"></table-service-types>


    </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import tableServiceTypes from '@/components/Tables/Stats/ServiceTypes.vue'
import BookingService from '@/services/BookingService'
// import modal from "@/components/Modals/Basic.vue";
import inputDatePicker from '@/components/Inputs/input-date-range.vue'
const  { mapActions: mapAppSettingActions } = createNamespacedHelpers('appSetting')
import branchSelect from '../../../components/branchSelect.vue'

import lineChart  from '@/components/Charts/Line'

export default {
    name: "StatsServTypeView",
    components: {
        // modal,
        lineChart,
        branchSelect,
        tableServiceTypes,
        inputDatePicker,
    },
    data () {
        return {
            key: 1,
            totalPost: 26,
            date: "",
            branch: 1,
            value: "All",
            modalShow: true,
            codeAccess: "",
            errorCode: false,
            status: "",
            disabled: false,
            stats: [],
            loaded:false,
            
        }
    },
    async created () {
       
        await this.getStatsServTypes(); 
    },
    methods: {
        ...mapAppSettingActions(["LOADING_STATUS"]),
        async getStatsServTypes(){            
            this.LOADING_STATUS(true);
            let response = await BookingService.getStatsServTypes({
                "begDate" : this.date != '' ? this.date.start : "", //opcional
                "endDate" : this.date != '' ? this.date.end : "",//opcional 
                branch: this.branch,
            });            
            if((response.status/100) == 2){
                this.stats  = response.data
                this.loaded = true
                this.key++
            }            
            this.LOADING_STATUS(false);
        },
        search() {
            this.getStatsServTypes()
        },
        reset() {
            this.date = "";
            this.getStatsServTypes()
        },
        onHandleBranch(response){
            this.branch = response
        }
        
    }
}
</script>